export default __webpack_public_path__ + "static/media/myCoins.c369fddb.png";